import React, { useEffect } from "react";
import styled from "styled-components";
// import { gsap } from "gsap";
import AOS from "aos";
import "aos/dist/aos.css";

function Index({ wandRight, zIndex }) {
  const wandRef = React.useRef(null);

  useEffect(() => {
    // gsap.from(wandRef.current, {
    //   x: wandRight ? "300" : "-300",
    //   duration: 1,
    //   // opacity: 0,
    //   delay: 0.5,
    //   scrollTrigger: {
    //     trigger: wandRef.current,
    //     toggleActions: "play none none reverse"
    //   }
    // });
    // }, [wandRight]);
    AOS.init();
  }, []);

  return (
    <Container
      wandRight={wandRight}
      ref={wandRef}
      data-aos="fade-up"
      data-aos-duration="800"
      zIndex={zIndex}
    >
      <div className="line" />
      <div className="circle" />
    </Container>
  );
}

export default Index;

const Container = styled.div`
  position: absolute;
  left: ${({ wandRight }) => (wandRight ? "unset" : "0")};
  right: ${({ wandRight }) => (wandRight ? "0" : "unset")};
  display: flex;
  justify-content: center;
  flex-direction: ${({ wandRight }) => (wandRight ? "row-reverse" : "row")};
  opacity: 0.5;
  z-index: ${({ zIndex }) => zIndex};
  .line {
    width: 270px;
    border: 0.5px solid #5a189a;
    height: 0;
    margin-top: 5px;
  }
  .circle {
    width: 10px;
    height: 10px;
    background: #5a189a;
    border-radius: 50%;
  }
`;
